import React from 'react';
import './followup.css';
import { FaFilePdf, FaDownload, FaSearch, FaFilter } from 'react-icons/fa';

const resources = {
  "Clinical Guidelines": [
    { title: "AAO Pediatric Eye Examination Guidelines", url: "/pdfs/aao-pediatric-guidelines.pdf", date: "2023" },
    { title: "Diabetic Retinopathy Management Protocol", url: "/pdfs/diabetic-retinopathy-protocol.pdf", date: "2022" },
    { title: "Glaucoma Diagnosis and Treatment Standards", url: "/pdfs/glaucoma-standards.pdf", date: "2023" }
  ],
  "Research Papers": [
    { title: "Myopia Progression in Children: 5-Year Study", url: "/pdfs/myopia-progression-study.pdf", date: "2021" },
    { title: "Dry Eye Disease: Latest Treatment Modalities", url: "/pdfs/dry-eye-treatment.pdf", date: "2022" },
    { title: "Contact Lens Materials: Oxygen Permeability Comparison", url: "/pdfs/cl-materials-research.pdf", date: "2020" }
  ],
  "Practice Management": [
    { title: "Optometric Practice Revenue Optimization", url: "/pdfs/practice-revenue.pdf", date: "2023" },
    { title: "Patient Retention Strategies for Optometrists", url: "/pdfs/patient-retention.pdf", date: "2022" },
    { title: "Digital Marketing for Eye Care Practices", url: "/pdfs/optom-marketing.pdf", date: "2021" }
  ],
  "Continuing Education": [
    { title: "Advanced Contact Lens Fitting Techniques", url: "/pdfs/advanced-cl-fitting.pdf", date: "2023" },
    { title: "Neuro-Optometric Rehabilitation Update", url: "/pdfs/neuro-optom-rehab.pdf", date: "2022" },
    { title: "Ocular Pharmacology: New Developments", url: "/pdfs/ocular-pharmacology.pdf", date: "2023" }
  ]
};

function FollowupResources() {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [activeCategory, setActiveCategory] = React.useState('All');

  const filteredResources = Object.entries(resources).reduce((acc, [category, items]) => {
    if (activeCategory !== 'All' && activeCategory !== category) return acc;
    
    const filteredItems = items.filter(item => 
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    if (filteredItems.length > 0) {
      acc.push([category, filteredItems]);
    }
    
    return acc;
  }, []);

  return (
    <div className="resources-container">
      <header className="resources-header">
        <h1>Follow-Up Resources</h1>
        <p className="subtitle">Evidence-based guidelines, research, and practice management tools for optometrists and opticians</p>
      </header>

      <div className="search-filter-container">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search resources..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div className="category-filter">
          <FaFilter className="filter-icon" />
          <select 
            value={activeCategory} 
            onChange={(e) => setActiveCategory(e.target.value)}
          >
            <option value="All">All Categories</option>
            {Object.keys(resources).map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="resources-grid">
        {filteredResources.map(([category, items]) => (
          <div key={category} className="resource-category">
            <h2 className="category-title">{category}</h2>
            <div className="resource-cards">
              {items.map((resource, index) => (
                <div key={index} className="resource-card">
                  <div className="pdf-icon">
                    <FaFilePdf />
                  </div>
                  <div className="resource-info">
                    <h3>{resource.title}</h3>
                    <span className="resource-date">{resource.date}</span>
                  </div>
                  <a 
                    href={resource.url} 
                    download 
                    className="download-btn"
                    aria-label={`Download ${resource.title}`}
                  >
                    <FaDownload />
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <footer className="resources-footer">
        <p>Last updated:4th September 2025</p>
        <p>Have a resource to suggest? <a href="mailto:info@optometryassociation.lk">Contact our editorial team</a></p>
      </footer>
    </div>
  );
}

export default FollowupResources;